import { useState } from "react";
import { toast } from "sonner";
import { adminApi, formatApiError } from "@/admin/api";
import { SERVICE_MAP } from "@/data/services";
import { absUrl } from "@/data/portfolio";
import { inputCls, ServiceSelect, HomeSwitch } from "@/admin/components/PortfolioFields";

export function PortfolioRow({ item, onSaved }) {
  const [edit, setEdit] = useState(null);
  const tid = item.slug;

  const save = async (patch) => {
    try {
      const { data } = await adminApi.patch(`/portfolio/${item.id}`, patch);
      onSaved(data.item);
      setEdit(null);
      toast.success("Saved");
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || e.message);
    }
  };

  const field = (k, type = "text") => (
    <input type={type} value={edit[k] ?? ""} onChange={(e) => setEdit({ ...edit, [k]: e.target.value })}
      className={inputCls} data-testid={`portfolio-edit-${k}-${tid}`} />
  );

  return (
    <tr className="hover:bg-zinc-50 align-middle" data-testid={`portfolio-row-${tid}`}>
      <td className="p-3">
        <div className="w-16 h-12 bg-zinc-100 bg-cover bg-center border border-zinc-200" style={item.thumb_url ? { backgroundImage: `url(${absUrl(item.thumb_url)})` } : {}} />
      </td>
      <td className="p-3 font-medium text-zinc-900 min-w-[200px]">{edit ? field("title") : <span data-testid={`portfolio-title-${tid}`}>{item.title}</span>}</td>
      <td className="p-3 text-xs min-w-[180px]">
        {edit ? <ServiceSelect value={edit.service} onChange={(v) => setEdit({ ...edit, service: v })} testId={`portfolio-edit-service-${tid}`} />
          : SERVICE_MAP[item.service]?.title || item.service}
      </td>
      <td className="p-3 text-xs w-28">{edit ? field("state") : item.state}</td>
      <td className="p-3 text-xs font-mono w-24">{edit ? field("year", "number") : item.year}</td>
      <td className="p-3">
        <HomeSwitch checked={item.show_on_home !== false} onChange={(v) => save({ show_on_home: v })} testId={`portfolio-home-switch-${tid}`} />
      </td>
      <td className="p-3 text-right whitespace-nowrap">
        {edit ? (
          <div className="inline-flex gap-2">
            <button onClick={() => save({ ...edit, year: Number(edit.year) || undefined })} className="px-3 h-9 bg-zinc-950 text-white text-xs hover:bg-[#0044FF] transition-colors" data-testid={`portfolio-save-btn-${tid}`}>Save</button>
            <button onClick={() => setEdit(null)} className="px-3 h-9 border border-zinc-300 text-xs" data-testid={`portfolio-cancel-btn-${tid}`}>Cancel</button>
          </div>
        ) : (
          <button onClick={() => setEdit({ title: item.title, service: item.service, state: item.state, year: item.year })}
            className="px-3 h-9 border border-zinc-300 text-xs hover:border-zinc-900 transition-colors" data-testid={`portfolio-edit-btn-${tid}`}>Edit</button>
        )}
      </td>
    </tr>
  );
}
